<template>
  <div class="testpaper_body">
    <div>
      <span style="font-size: 18px; font-weight: bold">理论题库</span>
    </div>
    <div>
      <el-row>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div style="display: flex; padding-top: 20px">
            <a-button type="primary" @click="opendialog">添加试卷</a-button>
          </div>
          <div style="padding-top: 20px">
            <el-table :data="paperData" border style="width: 100%">
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="80"
              >
              </el-table-column>
              <el-table-column prop="title" align="center" label="试卷名称">
              </el-table-column>
              <!--                            <el-table-column
                                                                align="center"
                                                                label="试卷内容">
                                                            <template slot-scope="scope">
                                                                <div v-for="item in scope.row.subjectJson" :key="item.subjectId">
                                                                    <div style="display: flex;justify-content: center;">
                                                                        <span>题干：</span>
                                                                        <div v-html="item.body"></div>
                                                                    </div>
                                                                    <div style="display: flex;justify-content: center;">
                                                                        <span>答案：</span>
                                                                        <div v-html="item.answer"></div>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                        </el-table-column>-->
              <el-table-column align="center" label="操作" width="80">
                <template slot-scope="scope">
                  <el-button type="text" @click="deletepaper(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-dialog
        title="添加"
        :visible.sync="centerDialogVisible"
        width="50%"
        center
      >
        <div>
          <div style="display: flex; justify-content: center">
            <div style="width: 90px; display: flex; align-items: center">
              <span>试卷名称：</span>
            </div>
            <el-input v-model="papertitle"></el-input>
          </div>
          <div style="margin-top: 20px; margin-bottom: 10px">
            <el-button size="small" @click="getradiolist">单选题</el-button>
            <el-button size="small" @click="getselectlist">多选题</el-button>
            <el-button size="small" @click="getjudgelist">判断题</el-button>
            <span style="margin-left: 20px"
              >已选{{ subjectString.length }}条</span
            >
          </div>

          <div style="padding-top: 20px" v-show="radio">
            <el-table
              :data="
                radiotable.slice(
                  (currentPage - 1) * pagesize,
                  currentPage * pagesize
                )
              "
              class="uploadList"
              stripe
              ref="multipleTable"
              tooltip-effect="dark"
              border
              :row-key="getRowKey"
              style="width: 100%"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
                width="55"
              >
              </el-table-column>
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="type"
                align="center"
                label="题型"
                width="100"
              >
              </el-table-column>
              <el-table-column align="center" label="题干">
                <template slot-scope="scope">
                  <div v-html="scope.row.body"></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="answer"
                align="center"
                label="答案"
                width="100"
              >
              </el-table-column>
            </el-table>
            <div class="page" style="margin-top: 30px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="radiotable.length"
              >
              </el-pagination>
            </div>
          </div>

          <div style="padding-top: 20px" v-show="select">
            <el-table
              :data="
                selecttable.slice(
                  (currentPage - 1) * pagesize,
                  currentPage * pagesize
                )
              "
              class="uploadList"
              stripe
              ref="multipleTable"
              tooltip-effect="dark"
              border
              :row-key="getRowKey"
              style="width: 100%"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
                width="55"
              >
              </el-table-column>
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="type"
                align="center"
                label="题型"
                width="100"
              >
              </el-table-column>
              <el-table-column align="center" label="题干">
                <template slot-scope="scope">
                  <div v-html="scope.row.body"></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="answer"
                align="center"
                label="答案"
                width="100"
              >
              </el-table-column>
            </el-table>
            <div class="page" style="margin-top: 30px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="selecttable.length"
              >
              </el-pagination>
            </div>
          </div>
          <div style="padding-top: 20px" v-show="judge">
            <el-table
              :data="
                judgetable.slice(
                  (currentPage - 1) * pagesize,
                  currentPage * pagesize
                )
              "
              class="uploadList"
              stripe
              ref="multipleTable"
              tooltip-effect="dark"
              border
              :row-key="getRowKey"
              style="width: 100%"
              @select="handleSelectionChange"
              @select-all="handleSelectionChange"
            >
              <el-table-column
                :reserve-selection="true"
                type="selection"
                width="55"
              >
              </el-table-column>
              <el-table-column
                type="index"
                align="center"
                label="序号"
                width="80"
              >
              </el-table-column>
              <el-table-column
                prop="type"
                align="center"
                label="题型"
                width="100"
              >
              </el-table-column>
              <el-table-column align="center" label="题干">
                <template slot-scope="scope">
                  <div v-html="scope.row.body"></div>
                </template>
              </el-table-column>
              <el-table-column
                prop="answer"
                align="center"
                label="答案"
                width="100"
              >
              </el-table-column>
            </el-table>
            <div class="page" style="margin-top: 30px">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="judgetable.length"
              >
              </el-pagination>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: "Testpaper",
  data() {
    return {
      currentIndex: "",
      currentPage: 1, //初始页
      pagesize: 10, //    每页的数据
      centerDialogVisible: false,
      radio: true,
      select: true,
      judge: true,
      radiotable: [],
      selecttable: [],
      judgetable: [],
      paperData: [],
      subjectJson: "",
      subjectData: [],
      papertitle: "",
      subjectString: [],
      tables: [],
      temporaryData: {},
    };
  },
  mounted() {
    this.getradiolist();
    this.getpaperlist();
  },
  methods: {
    getRowKey(row) {
      return row.subjectId;
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
      // console.log(this.pagesize) //每页下拉显示数据
    },
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      // console.log(this.currentPage) //点击第几页
    },
    opendialog() {
      this.centerDialogVisible = true;
      this.getradiolist();
    },
    deletepaper(row) {
      let that = this;
      this.$confirm({
        title: "确定要永久删除数据，该数据不可恢复?",
        content: "",
        okType: "danger",
        okText: "删除",
        cancelText: "取消",
        onOk() {
          let url = "/paper/delete?paperId=";
          that.$axios.delete(url + row.paperId).then((resp) => {
            if (resp.data.code === 200) {
              that.$message.success("操作成功！");
              that.getpaperlist();
            } else {
              that.$message.error("操作失败！");
            }
          });
        },
        onCancel() {},
      });
    },
    // getlist() {
    //
    //     let url = '/subject/list?type=单选题';
    //     this.$axios.get(url).then((resp) => {
    //         console.log('ti', resp);
    //         if (resp.data.code === 200) {
    //             this.radiotable = resp.data.result
    //         }
    //     })
    // },
    getpaperlist() {
      let url = "/paper/list";
      this.$axios.get(url).then((resp) => {
        console.log("试卷", resp);
        if (resp.data.code === 200) {
          this.paperData = resp.data.result;
          var ndata = [];
          for (let i = 0; i < this.paperData.length; i++) {
            let str = resp.data.result[i].subjectJson;
            var data = str.split("&");
            this.paperData[i].subjectJson = ndata;
          }

          var enddata = data;

          for (let j = 0; j < enddata.length; j++) {
            let json = JSON.parse(enddata[j]);
            ndata.push(json);
          }
        }
      });
    },
    handleSelectionChange(list, row) {
      console.log(list);
      console.log(row);
      let index = -1;

      if (typeof row !== "undefined") {
        //添加
        this.subjectString.find((data, i) => {
          if (data === row) {
            index = i;
          }
        });

        if (index !== -1) {
          this.subjectString.splice(index, index + 1);
        } else {
          this.subjectString.push(row);
        }
      } else {
        if (list.length === 0) {
          let lists = [];
          if (this.radio) {
            lists = this.radiotable;
          } else if (this.select) {
            lists = this.selecttable;
          } else {
            lists = this.judgetable;
          }
          for (let i = 0; i < lists; i++) {
            let index = -1;
            this.subjectString.find((data, i) => {
              if (data === lists[i]) {
                index === i;
              }
            });
            if (index !== -1) {
              this.subjectString.delete(lists[i]);
            }
          }
        } else {
          this.subjectString = this.subjectString.concat(list);
        }
      }
      console.log(this.subjectString);

      // for (let i = 0; i < val.length; i++) {
      //     let form = {
      //         order: 0,
      //         subjectId: '',
      //         answer: '',
      //         score: 1.0
      //     };
      //     form.subjectId = val[i].subjectId;
      //     form.answer = val[i].answer;
      //     this.subjectString.push(form)
      //     console.log('str', form)
      // }
    },

    // 单选列表
    getradiolist() {
      this.radio = !this.radio;
      this.select = false;
      this.judge = false;
      if ((this.radio = true)) {
        this.radio = this.radio;
      }
      let url = "/subject/list?type=单选题";
      this.$axios.get(url).then((resp) => {
        console.log("单选题", resp);
        if (resp.data.code === 200) {
          this.radiotable = resp.data.result;
        }
      });
    },
    //多选列表
    getselectlist() {
      this.select = !this.select;
      this.radio = false;
      this.judge = false;
      if ((this.select = true)) {
        this.select = this.select;
      }
      let url = "/subject/list?type=多选题";
      this.$axios.get(url).then((resp) => {
        console.log("多选题", resp);
        if (resp.data.code === 200) {
          this.selecttable = resp.data.result;
        }
      });
    },
    //判断列表
    getjudgelist() {
      this.judge = !this.judge;
      this.radio = false;
      this.select = false;
      if ((this.judge = true)) {
        this.judge = this.judge;
      }
      let url = "/subject/list?type=判断题";
      this.$axios.get(url).then((resp) => {
        console.log("判断题", resp);
        if (resp.data.code === 200) {
          this.judgetable = resp.data.result;
        }
      });
    },
    submit() {
      let url = "/paper/save";
      for (let i = 0; i < this.subjectString.length; i++) {
        this.subjectString[i].order = i;
      }
      let param = {
        subjectJson: JSON.stringify(this.subjectString),
        title: this.papertitle,
      };
      this.$axios.post(url, param).then((resp) => {
        if (resp.data.code === 200) {
          this.centerDialogVisible = false;
          this.papertitle = "";
          this.subjectString = "";
          this.$message.success("添加成功！");
          this.getpaperlist();
        } else {
          this.$message.error("添加失败！");
        }
      });
      location.reload();
    },
    cancel() {
      this.centerDialogVisible = false;
      location.reload();
    },
  },
};
</script>

<style scoped>
.ant-btn-primary {
  color: #ffffff;
  font-weight: bolder;
  background-color: skyblue;
  border-color: skyblue;
}

.el-button--primary {
  color: #ffffff;
  font-weight: bolder;
  background-color: skyblue;
  border-color: skyblue;
}
</style>
